import script from "./AsNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./AsNumber.vue?vue&type=script&setup=true&lang=js"

import "./AsNumber.vue?vue&type=style&index=0&id=a409e916&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a409e916"]])

export default __exports__